

<template>
    <div>
        <h1 class="font-bold my-10">
            {{ $t('nav.commentRules') }}
        </h1>
        <p class="mb-40" v-html="policy">
            
        </p>
    </div>
</template>

<script>
import api from '@/api';

export default {
    name: 'comment',
    components: {
    },
    data(){
        return {
            loading: false,
            policy: []
        }
    },
    methods: {
        async getPolicy(){
            this.loading = true
            try{ 
                const response = await api.get('info/')
                this.policy = response.data['comment_policy']
            }
            catch(e){
                console.log(e)
            }
            this.loading = false

        }
    },
    computed: {

    },
    async created(){
        await this.getPolicy()
    }
}
</script>